import { Component, Input } from '@angular/core';
import { TireSeasonType } from 'src/app/core/interfaces/products-types/tire-product.interface';

@Component({
  selector: 'app-season-icon',
  templateUrl: './season-icon.component.html',
  styleUrls: ['./season-icon.component.scss']
})
export class SeasonIconComponent {
  @Input() season: TireSeasonType | null | undefined;
  @Input() showLabel: boolean = false;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  get seasonIcon(): string {
    switch (this.season) {
      case TireSeasonType.WINTER:
        return 'assets/tyres/season-winter.svg';
      case TireSeasonType.SUMMER:
        return 'assets/tyres/season-summer.svg';
      case TireSeasonType.ALL_SEASON:
        return 'assets/tyres/season-all.svg';
      default:
        return '';
    }
  }

  get seasonLabel(): string {
    switch (this.season) {
      case TireSeasonType.WINTER:
        return 'Winter';
      case TireSeasonType.SUMMER:
        return 'Summer';
      case TireSeasonType.ALL_SEASON:
        return 'All Season';
      default:
        return '-';
    }
  }

  get seasonAlt(): string {
    switch (this.season) {
      case TireSeasonType.WINTER:
        return 'Winter tire';
      case TireSeasonType.SUMMER:
        return 'Summer tire';
      case TireSeasonType.ALL_SEASON:
        return 'All season tire';
      default:
        return 'Season icon';
    }
  }
} 